jQuery(function($) {
	var homeHero = $('.home .hero');
	var homeHeroVideo = $('.home .hero_video');
	var window =  $(window);

	if (!homeHero.length)
		return;

	var showText = function() {
		var scrollTop = window.scrollTop();
		if(scrollTop > 0) {
			setTimeout(function() {
				$('.hero.home .text').addClass('show');
				setTimeout(function() {
					$('.hero.home .text').removeClass('show');
				}, 3000);
				setTimeout(function() {
					$('.hero.home .closing_text').addClass('show');
					setTimeout(function() {
						$('.hero.home .closing_text').removeClass('show');
					}, 3000);
				}, 7000);
			}, 2000);
		}
	}

	if (!homeHeroVideo.length)
		return;

	var showedFirstBlurb = false;
	var showedSecondBlurb = false;

	var timeText = setInterval(function() {
		if (video.currentTime > 32.5 && !showedSecondBlurb) {
			showedSecondBlurb = true;
			$('.hero.home .closing_text').addClass('show');
			setTimeout(function() {
				$('.hero.home .closing_text').removeClass('show');
			}, 4000);
		}
	}, 50);

	var video = homeHero.find('video')[0];

	var awaitVideo = setInterval(function() {
		if (video.readyState == 4) {
			$(video).addClass('loaded');
			clearInterval(awaitVideo);
		}
	}, 500);
});